// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"43ab90c6","255":"81480fcb","348":"d24fccf0","584":"e22f1800","731":"5d8315a1","766":"a5fde4ed","834":"cda3e7d7","858":"d0bd6b98","937":"709aed14"}[chunkId] + ".chunk.js";
};